import React from 'react';

const FooterLogo = () => {
  return (
    <div className="FooterLogo">
      <svg
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="1.414"
        clipRule="evenodd"
        viewBox="0 0 356 50">
        <path
          className="Logo__txt"
          fillRule="nonzero"
          d="M254.3 44.55h-2.5c-.2-.4-.3-2.4-.4-6.2-1.4 2.7-4.4 6.6-12.5 6.6-11.1 0-16.8-8.4-16.8-19.4 0-11.5 6.1-20.2 17.4-20.2 8.3 0 13.9 4.4 15.1 11.5h-3c-1.7-5.5-5.5-8.7-12.2-8.7-9.7 0-14.1 7.5-14.1 17.3 0 8.8 4.3 16.8 13.7 16.8 9.7 0 12.4-6.3 12.4-14.9v-.4h-12.5v-2.8h15.3v20.4h.1zM281.6 36.45c0 2.7.1 7 .1 8.1h-2.6c-.1-.7-.2-2.5-.2-4.8-1.2 3.3-4 5.5-8.9 5.5-4 0-9.1-1.5-9.1-10v-18.4h2.7v17.7c0 4 1.3 7.9 6.7 7.9 6.2 0 8.5-3.5 8.5-11.4v-14.2h2.8v19.6zM288.8 3.85h2.8v5.4h-2.8v-5.4zm0 13h2.8v27.7h-2.8v-27.7zM319.9 3.85v32.7c0 2.6 0 5.2.1 7.9h-2.6c-.1-.7-.2-3.3-.2-4.6-1.4 3.4-4.5 5.3-9.3 5.3-7.2 0-11.5-5.9-11.5-14.1 0-8.5 4.7-14.8 12.2-14.8 5.5 0 7.7 2.4 8.6 4.1V3.85h2.7zm-20.5 27.1c0 7.6 3.9 11.6 8.7 11.6 7.3 0 9.3-5 9.3-12.5 0-7.1-1.7-11.2-8.8-11.2-5.5 0-9.2 4.3-9.2 12.1zM327.7 31.05c.1 7.1 3.6 11.5 8.9 11.5 5.2 0 7-2.9 7.9-5.2h2.8c-1.2 3.6-4.1 7.8-10.9 7.8-8.4 0-11.6-7.2-11.6-14.2 0-7.9 3.9-14.7 12-14.7 8.5 0 11.2 7.3 11.2 12.5 0 .8 0 1.5-.1 2.3h-20.2zm17.5-2.4c-.1-5.5-3-9.8-8.4-9.8-5.7 0-8.3 4-8.9 9.8h17.3zM90.2 18.65c0 4.4-1.3 7.8-3.9 10.2-2.6 2.4-6.3 3.6-11.1 3.6h-3v13.1H61.6V6.15h13.6c5 0 8.7 1.1 11.2 3.3 2.5 2.2 3.8 5.2 3.8 9.2zm-18 5.2h1.9c1.6 0 2.9-.4 3.8-1.3.9-.9 1.4-2.1 1.4-3.7 0-2.7-1.5-4-4.4-4h-2.7v9zM112.4 14.35c-2.5 0-4.5 1-5.9 3.1-1.4 2.1-2.1 4.9-2.1 8.6 0 7.6 2.9 11.4 8.7 11.4 1.7 0 3.4-.2 5.1-.7 1.7-.5 3.3-1.1 4.9-1.8v9c-3.3 1.5-7 2.2-11.2 2.2-5.9 0-10.5-1.7-13.7-5.2-3.2-3.5-4.8-8.4-4.8-15 0-4.1.8-7.7 2.3-10.8 1.5-3.1 3.7-5.5 6.6-7.1 2.9-1.6 6.3-2.5 10.2-2.5 4.3 0 8.3.9 12.2 2.8l-3.3 8.4c-1.5-.7-2.9-1.3-4.4-1.7-1.5-.4-2.9-.7-4.6-.7zM146.2 45.55l-8.1-28.4h-.2c.4 4.8.6 8.6.6 11.3v17.1h-9.4V6.15h14.2l8.2 28h.2l8.1-28H174v39.4h-9.8v-17.3-3c0-1.1.1-3.8.4-8.1h-.2l-8 28.3h-10.2v.1zM214.6 45.55h-10.7v-16h-12.4v16h-10.7V6.15h10.7v14.6h12.4V6.15h10.7v39.4z"
        />
        <g>
          <path
            className="Logo__check"
            fillRule="nonzero"
            d="M24.278 6.251C13.94 6.251 5.529 14.662 5.529 25c0 10.339 8.41 18.75 18.749 18.75 10.338 0 18.75-8.411 18.75-18.75 0-10.338-8.412-18.749-18.75-18.749zm0 41.283C11.852 47.534 1.743 37.426 1.743 25c0-12.425 10.11-22.534 22.535-22.534 12.426 0 22.535 10.109 22.535 22.534 0 12.426-10.11 22.534-22.535 22.534z"
          />
          <path
            className="Logo__check"
            fillRule="nonzero"
            d="M15.488 24.049c1.809 2.083 4.302 5.72 5.073 8.166 0 0 2.438-13.228 11.143-20.25L36.452 14s-8.72 4.65-12.955 24.209l-4.195 2.34s-1.845-8.499-8.135-13.894l4.321-2.606z"
          />
        </g>
      </svg>
    </div>
  );
};

export default FooterLogo;



// WEBPACK FOOTER //
// ./src/components/logos/FooterLogo.js